// Shared emotion constants

export const EMOTION_KEYS = ['happy', 'sad', 'angry', 'fear', 'disgust', 'surprise'];
